
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class ApprovalInBOMGrid extends Serenity.EntityGrid<ApprovalInBOMRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalInBOM'; }
        protected getDialogType() { return ApprovalInBOMDialog; }
        protected getIdProperty() { return ApprovalInBOMRow.idProperty; }
        protected getInsertPermission() { return ApprovalInBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInBOMRow.localTextPrefix; }
        protected getService() { return ApprovalInBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}